import { mstInterface } from 'api-interface/mst.interface';


export class MstNotificationModel implements mstInterface.notification.GetRes {

        /** お知らせid */
        id: string;
        
        /** お知らせ内容 */
        content: string;

        /** お知らせリンク先 */
        link: string;

        /** お知らせ日 */
        date: string;

        /** 削除フラグ */
        del: boolean;
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/model/mst.notification.model.ts